import React from 'react';
import { Control } from 'react-hook-form/dist/types/form';
import { Typography } from '@mui/material';
import { Column, ListingForm } from 'components/shared/TableListing';
import { CurrencyInputField } from 'components/form/rhf';
import { SubsidyTableRow } from '../types';
import { ApprovedSubsidyCell } from '../ui/subsidyTable/ApprovedSubsidyCell';
import { DealerContributionCell } from '../ui/subsidyTable/DealerContributionCell';
import { OemContributionCell } from '../ui/subsidyTable/OemContributionCell';

export const subsidyTableHeaderColumns: Column<SubsidyTableRow>[] = [
  { header: 'DNET', renderKey: 'dnet' },
  { header: 'DNET Coefficient', renderKey: 'dnetCoefficient' },
  { header: 'Finance Amount', renderKey: 'financeAmount' },
  { header: 'Subsidy %', renderKey: 'subsidyPercent' },
  { header: 'Approved Subsidy Amount', renderKey: 'approvedSubsidyAmount' },
  { header: 'Dealer Contribution', renderKey: 'dealerContribution' },
  { header: 'OEM Contribution', renderKey: 'oemContribution' },
];

interface StoredValues {
  approvedSubsidyAmount?: number;
  dealerContribution?: number;
  oemContribution?: number;
}

export const getSubsidyTableColumns = ({
  control,
  subsidyPercent,
  dnetCoefficient,
  dealerParticipationPercent,
  disabled,
  storedValues,
}: {
  control: Control<ListingForm<SubsidyTableRow>>;
  subsidyPercent: number;
  dnetCoefficient: number;
  dealerParticipationPercent: number;
  disabled?: boolean;
  storedValues?: StoredValues;
}): Column<SubsidyTableRow>[] => [
  {
    header: 'DNET',
    renderKey: 'dnet',
    renderCell: ({ rowIndex }) => (
      <CurrencyInputField
        label=""
        control={control as any}
        name={`bodyFields.${rowIndex}.dnet`}
        textFieldProps={{ disabled }}
      />
    ),
  },
  {
    header: 'DNET Coefficient',
    renderKey: 'dnetCoefficient',
    renderCell: () => <Typography>{dnetCoefficient}</Typography>,
  },
  {
    header: 'Finance Amount',
    renderKey: 'financeAmount',
    renderCell: ({ rowIndex }) => (
      <CurrencyInputField
        label=""
        control={control as any}
        name={`bodyFields.${rowIndex}.financeAmount`}
        textFieldProps={{ disabled }}
      />
    ),
  },
  {
    header: 'Subsidy %',
    renderKey: 'subsidyPercent',
    renderCell: () => <Typography>{subsidyPercent}%</Typography>,
  },
  {
    header: 'Approved Subsidy Amount',
    renderKey: 'approvedSubsidyAmount',
    renderCell: ({ rowIndex }) => (
      <ApprovedSubsidyCell
        rowIndex={rowIndex}
        subsidyPercent={subsidyPercent}
        dnetCoefficient={dnetCoefficient}
        dealerParticipationPercent={dealerParticipationPercent}
        storedValue={storedValues?.approvedSubsidyAmount}
      />
    ),
  },
  {
    header: 'Dealer Contribution',
    renderKey: 'dealerContribution',
    renderCell: ({ rowIndex }) => (
      <DealerContributionCell
        rowIndex={rowIndex}
        subsidyPercent={subsidyPercent}
        dnetCoefficient={dnetCoefficient}
        dealerParticipationPercent={dealerParticipationPercent}
        storedValue={storedValues?.dealerContribution}
      />
    ),
  },
  {
    header: 'OEM Contribution',
    renderKey: 'oemContribution',
    renderCell: ({ rowIndex }) => (
      <OemContributionCell
        rowIndex={rowIndex}
        subsidyPercent={subsidyPercent}
        dnetCoefficient={dnetCoefficient}
        dealerParticipationPercent={dealerParticipationPercent}
        storedValue={storedValues?.oemContribution}
      />
    ),
  },
];
